import * as React from 'react';
import { Box, Toolbar, Typography, Button, TextField, InputAdornment, IconButton, Divider } from '@mui/material';
// icon import
import SearchIcon from '@mui/icons-material/Search';
// component import
import AddUserModal from '../components/AddUserModal';
import UCard from '../components/UserCard';

const drawerWidth = 240;

function Main(props) {
    if (!localStorage.getItem('loggedin')){
        window.location = "/login"
    }
    const [edit,setEdit] = React.useState(true)
    const [cardData, setCardData] = React.useState(null);
    const [loading,setLoading] = React.useState(true)
    const [cluster,setCluster] = React.useState("NCL,SECL")
    const [seed, setSeed] = React.useState("");

    
    React.useEffect(() => {
        users()
    },[])

//    const users = async() => {
//        const response = await fetch('https://'+process.env.REACT_APP_PRIVATE_IP+':'+process.env.REACT_APP_PORT+ '/' + process.env.REACT_APP_API_NAME + '/get_users',{method : "GET"});
//        const received_data = (await response.json())['data']
//        setCardData(received_data)
//        setLoading(!loading)
//    }

    const users = async () => {
        const response = await fetch(
            `https://${process.env.REACT_APP_PRIVATE_IP}:${process.env.REACT_APP_PORT}/${process.env.REACT_APP_API_NAME}/get_users`,
            {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${process.env.REACT_APP_TOKEN}`,
                    "Content-Type": "application/json"
                }
            }
        );

        const json = await response.json();
        console.log("API RESPONSE:", json);

        const received_data = json.data; // or json['data']
        setCardData(received_data);
        setLoading(!loading);
    };



    const checkSearch = (event) => {
        setSeed(event.target.value.trim())
    }

    let filterList;
    if (!loading){
        filterList = []
        cardData.map((e,i)=>{
            if (seed!=""){
                if ((!e['first_name'].toLowerCase().indexOf(seed.toLowerCase()) || !e['last_name'].toLowerCase().indexOf(seed.toLowerCase()) || !e['user_name'].toLowerCase().indexOf(seed.toLowerCase()))){
                    filterList.push(e)
                }
            }else{
                if ((!e['first_name'].toLowerCase().indexOf(seed.toLowerCase()) || !e['last_name'].toLowerCase().indexOf(seed.toLowerCase()) || !e['user_name'].toLowerCase().indexOf(seed.toLowerCase())) && (cluster == Object.keys(JSON.parse(e['site_access'])).filter(k => JSON.parse(e['site_access'])[k].length>0).join(','))){
                    filterList.push(e)
                }
            }
        })
    }else{
        filterList = []
    }
    
    const restoreUsers = async() =>{
        const response = await fetch('https://'+process.env.REACT_APP_PRIVATE_IP+':'+process.env.REACT_APP_PORT+ '/' + process.env.REACT_APP_API_NAME + '/restore_user',{method : "POST"});
        const returned_response = await response.json()
        if (returned_response.status_code!=200 && returned_response.status_code!=201){
            alert(returned_response.message)
        }else{
            window.location.reload()
        }
    }

    if (!loading){
        return(
            <>
                <Box component="main" sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}>
                    <Toolbar />
                    
                    <div>
                        
                        {/* section 1 - header*/}
                        <div id="headerUM">
                            <div style={{display:"flex", alignItems:"center"}}>
                                <Typography variant='h4' sx={{width:'fit-content',mr:4}}>Active Users</Typography>
                                <div style={{display:"flex",padding:"30px 0"}}>
                                    {/* <Button onClick={()=>{setEdit(!edit)}} variant="outlined" color='primary' sx={{marginRight:"20px"}}>{edit ? "Save" : "Edit"} Users</Button> */}
                                    <AddUserModal openDialog={props.openDialog} />
                                    <Button onClick={restoreUsers} variant="outlined" color='primary' sx={{marginLeft:"20px"}}>Restore Users</Button>
                                </div>
                            </div>

                            <Typography variant='h5' sx={{width:'fit-content',mr:4}}>Total Users - {filterList.length}</Typography>
                        </div>
                        <Divider/>
                        
                        {/* section 2 - searchbar*/}
                        <div id='postHeaderUM'>
                            <TextField sx={{marginBottom:"10px"}} id="outlined-search" label="Search by Name, User Name" type="search" onChange={checkSearch} InputProps={{
                                endAdornment: (
                                <InputAdornment>
                                    <IconButton>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                                )
                            }}/>
                            <div id='clusterUMSection'style={{marginBottom:"10px"}} >
                                <Button className={ cluster === "NCL,SECL" ? 'active' : ''} variant="outlined" onClick={() => {setCluster("NCL,SECL");}}>NCL + SECL Access</Button>
                                <Button className={ cluster === "NCL" ? 'active' : ''} variant="outlined" onClick={() => {setCluster("NCL");}}>Only NCL Access</Button>
                                <Button className={ cluster === "SECL" ? 'active' : ''} variant="outlined" onClick={() => {setCluster("SECL");}}>Only SECL Access</Button>
                            </div>
                        </div>

                        <div id="userCards">
                            {filterList.map((card) => 
                                <UCard data = {card} edit={edit} filter = {seed} openDialog={props.openDialog}/>
                            )}
                            <div style={{padding:"0px 15px 15px 15px",margin:"15px 0px",display:"flex",flexDirection:'column',width:"30%"}}></div>
                            <div style={{padding:"0px 15px 15px 15px",margin:"15px 0px",display:"flex",flexDirection:'column',width:"30%"}}></div>
                            <div style={{padding:"0px 15px 15px 15px",margin:"15px 0px",display:"flex",flexDirection:'column',width:"30%"}}></div>
                            <div style={{padding:"0px 15px 15px 15px",margin:"15px 0px",display:"flex",flexDirection:'column',width:"30%"}}></div>
                        </div>
                        
                    </div>
                    
                </Box>
            </>
        )
    }
}

export default Main;
